/**
 * @file Custom print icon component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import PrinterIcon from '../../icons/PrinterIcon';

const propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

const defaultProps = {
  size: 36,
};

const CustomPrintIcon = ({ backgroundColor, color, size, className }) => {
  return (
    <span
      className={classNames({
        'custom-print-icon': true,
        [className]: !!className,
      })}
      style={{ backgroundColor, width: `${size}px`, height: `${size}px` }}
    >
      <PrinterIcon color={color} size={size * 0.55} />
    </span>
  );
};

CustomPrintIcon.propTypes = propTypes;
CustomPrintIcon.defaultProps = defaultProps;

export default CustomPrintIcon;
